export * from '@primeuix/themes/nora/organizationchart';
export { default } from '@primeuix/themes/nora/organizationchart';
